import type { FilterFn, Row } from '@tanstack/react-table';

// Normaliza para búsqueda: minúsculas + sin acentos (NFD + strip diacríticos combinantes
// U+0300–U+036F). Así "García" matchea "garcia". Centralizado para que las 7 tablas busquen igual.
export function normalizeForSearch(value: string): string {
    return value.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
}

// Coerce a string SOLO valores con representación textual sensata (primitivos + arrays de los
// mismos). Objetos arbitrarios → '' (evita "[object Object]" en el haystack del search).
function toSearchable(value: unknown): string {
    if (value == null) return '';
    if (typeof value === 'string') return value;
    if (typeof value === 'number' || typeof value === 'boolean') return String(value);
    if (Array.isArray(value)) return value.map(toSearchable).join(' ');
    return '';
}

// Global filter case/accent-insensitive sobre el valor renderizado de cada columna con
// `enableGlobalFilter` (default true para accessor columns). Concatena los valores string de la fila
// y matchea por substring. Las columnas con cell custom (badge de estado, target) exponen su texto
// buscable vía `accessorFn`/`getValue` en cada tabla.
export const globalFilterFn: FilterFn<unknown> = (
    row: Row<unknown>,
    _columnId: string,
    filterValue: unknown,
): boolean => {
    const needle = normalizeForSearch(toSearchable(filterValue)).trim();
    if (!needle) return true;
    const haystack = row
        .getAllCells()
        .map((cell) => (cell.column.getCanGlobalFilter() ? toSearchable(cell.getValue()) : ''))
        .join(' ');
    return normalizeForSearch(haystack).includes(needle);
};
